import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Box, Snackbar } from "@mui/material";
import axios from "axios";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

function SetUsdPrice() {
  const [formData, setFormData] = useState({ price: "" });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [SnackbarMsg, setSnackbarMsg] = useState("");

  // Handle input change
  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) { // Only allow positive numbers and decimals
      setFormData({ price: value });
    }
  };

  // Handle API call on Save
  const handleSaveUSD = async () => {
    const sessionToken = localStorage.getItem("sessionToken");

    if (!formData.price.trim()) {
      setSnackbarMsg("Price is required");
      setOpenSnackbar(true);
      return;
    }

    try {
      const response = await axios.post(
        `https://api.exampladmedia.com/api/publications/setUsdConversionRate?rate=${formData.price}`,
        null,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionToken,
          },
        }
      );

      if (response.status === 200) {
        setSnackbarMsg("USD Conversion Rate updated successfully!");
        setOpenSnackbar(true);
        setFormData({ price: "" }); // Clear input after success
      } else {
        setSnackbarMsg(response.data);
      }
    } catch (error) {
      setSnackbarMsg("Error updating USD conversion rate.");
      console.error("Error calling the API:", error);
    }
  };

  return (
    <DashboardLayout>
      <MDBox
        pt={3}
        pb={3}
        height="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ overflow: "hidden" }}
      >
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={8} md={6}>
            <Card sx={{ display: "flex", flexDirection: "column", alignItems: "center", p: 3 }}>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
              >
                <h2 style={{ color: "white", margin: 0 }}>Set USD Price</h2>
              </MDBox>
              <MDBox
                py={4}
                px={3}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                width="100%"
              >
                <Grid container spacing={2} direction="column" alignItems="center">
                  <Grid item xs={12} style={{ width: "100%", paddingLeft: 90 }}>
                    <TextField
                      fullWidth
                      label="USD Price"
                      variant="outlined"
                      name="price"
                      value={formData.price}
                      onChange={handleInputChange}
                      type="number"
                      inputMode="decimal"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      sx={{ maxWidth: 400 }}
                    />
                  </Grid>
                </Grid>
                <Box display="flex" justifyContent="center" mt={3} gap={2}>
                  <Button variant="contained" color="primary" style={{ color: "white" }} onClick={handleSaveUSD}>
                    Save
                  </Button>
                </Box>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Snackbar open={openSnackbar} message={SnackbarMsg} autoHideDuration={2000} onClose={() => setOpenSnackbar(false)} anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ zIndex: 1 }} />
    </DashboardLayout>
  );
}

export default SetUsdPrice;
